import React from 'react';
import { useCart } from '../context/CartContext';
import { X, Plus, Minus, ShoppingBag, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const CartDrawer = () => {
  const { items, remove, setQty, subtotal, shipping, total, open, setOpen } = useCart();
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex justify-end">
      <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
      <div className="relative w-full max-w-md h-full bg-[#FFF4E6] shadow-2xl flex flex-col">
        <div className="flex items-center justify-between p-5 border-b-2 border-black/10">
          <div className="flex items-center gap-2">
            <ShoppingBag size={20} />
            <div className="font-display text-2xl uppercase">Your Bowl</div>
          </div>
          <button onClick={() => setOpen(false)} className="w-9 h-9 rounded-full bg-white crunch-shadow-sm flex items-center justify-center"><X size={18} /></button>
        </div>

        <div className="flex-1 overflow-y-auto p-5 space-y-3">
          {items.length === 0 && (
            <div className="text-center py-16">
              <div className="font-display text-3xl uppercase">Empty bowl.</div>
              <p className="font-brico opacity-70 mt-2">Add some crunch to fill it up.</p>
              <Link to="/shop" onClick={() => setOpen(false)} className="btn-chunky primary mt-5 inline-flex">Browse Snacks</Link>
            </div>
          )}
          {items.map((it) => (
            <div key={it.product_id} className="bg-white rounded-2xl crunch-shadow-sm p-3 flex items-center gap-3">
              <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0" style={{ background: it.color + '33' }}>
                <img src={it.image} alt={it.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display uppercase">{it.title}</div>
                <div className="text-sm font-brico opacity-70">₹{it.price}</div>
              </div>
              <div className="flex items-center gap-2">
                <button onClick={() => setQty(it.product_id, it.qty - 1)} className="w-8 h-8 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center"><Minus size={14} /></button>
                <span className="font-bold w-6 text-center">{it.qty}</span>
                <button onClick={() => setQty(it.product_id, it.qty + 1)} className="w-8 h-8 rounded-full bg-[#1a1a1a] text-[#FFF4E6] flex items-center justify-center"><Plus size={14} /></button>
              </div>
              <button onClick={() => remove(it.product_id)} className="w-8 h-8 rounded-full text-[#E63946] flex items-center justify-center"><Trash2 size={16} /></button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="p-5 border-t-2 border-black/10 space-y-2">
            <div className="flex items-center justify-between font-brico"><span>Subtotal</span><span className="font-bold">₹{subtotal}</span></div>
            <div className="flex items-center justify-between font-brico"><span>Shipping</span><span className="font-bold">{shipping === 0 ? 'FREE' : `₹${shipping}`}</span></div>
            <div className="flex items-center justify-between font-display text-2xl uppercase pt-2 border-t-2 border-black/10"><span>Total</span><span>₹{total}</span></div>
            <Link to="/checkout" onClick={() => setOpen(false)} className="btn-chunky primary w-full justify-center mt-3">Checkout</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartDrawer;
